/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_SearchInputs */

const cs_ebr_search = /** @type {(inputs: Ebr_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat (ID, název, e-mail)`)
};

const en_ebr_search = /** @type {(inputs: Ebr_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search (ID, title, e-mail)`)
};

/**
* | output |
* | --- |
* | "Search (ID, title, e-mail)" |
*
* @param {Ebr_SearchInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_search = /** @type {((inputs?: Ebr_SearchInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_SearchInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_search(inputs)
	return cs_ebr_search(inputs)
});